module.exports = __webpack_public_path__ + "static/media/signature.cd5e14a8.svg";